import { createEffect, createEvent, createStore } from "effector";
import { confirmChangeBaseSelections } from "./confirmChangeFns";
import { resetAllSelectedStores } from "./resetAllSelected";

export type SelectedPersonTypes = {
  id: number;
  quantity: number;
  name: string;
}[];

export const resetSelectedPersonTypes = createEvent(
  "reset selected person types"
);
export const $selectedPersonTypes = createStore<SelectedPersonTypes>([])
  .reset(resetSelectedPersonTypes)
  .reset(resetAllSelectedStores);

interface OnChangeParams {
  id: number;
  qty: number;
  name: string;
}
export const selectedPersonTypesApi = {
  onChange: createEffect(
    async (value: OnChangeParams): Promise<OnChangeParams> => {
      if (!(await confirmChangeBaseSelections())) {
        throw new Error("User declined date range change.");
      }

      return value;
    }
  ),
  set: createEvent<SelectedPersonTypes>(),
};

$selectedPersonTypes.on(
  selectedPersonTypesApi.onChange.doneData,
  (store, value) => {
    const { id, qty, name } = value;
    const storeCloned = [...store];

    const item = storeCloned.find((i) => i.id === id);
    if (item) {
      if (qty === 0) {
        storeCloned.splice(storeCloned.indexOf(item), 1);
      } else {
        item.quantity = qty;
      }
    } else {
      storeCloned.push({ id, quantity: qty, name });
    }

    return storeCloned;
  }
);

$selectedPersonTypes.on(selectedPersonTypesApi.set, (s, v) => v);

export const $selectedPersonTypesQty = $selectedPersonTypes.map((store) => {
  return store.reduce((acc, { quantity }) => acc + quantity, 0);
});
